import { Callout } from "@/components/ui";
import type { RxBenefitsCoverageAlert } from "./PrescriptionBenefits/types";

type CalloutVariant = "info" | "danger" | "success" | "warning";

const ALERT_VARIANT_MAP: Partial<Record<string, CalloutVariant>> = {
  DrugExclusion: "danger",
  NotOnFormulary: "danger",
  PharmacyOutOfNetwork: "danger",
  PlanLimitExclusion: "danger",
  FullCostNotCovered: "warning",
  MandatoryGeneric: "warning",
  MedicalNecessity: "warning",
  StepTherapy: "warning",
  AgeLimits: "warning",
  GenderLimits: "warning",
  QuantityLimits: "info",
  QuantityLimitExceeded: "info",
  QuantityNotValid: "info",
  DaysSupplyExceeded: "info",
  ExcessiveUtilization: "info",
  ResourceLink: "info",
  TextMessage: "info",
};

const alertVariant = (code: string | null): CalloutVariant =>
  (code != null && ALERT_VARIANT_MAP[code]) || "warning";

interface CoverageAlertsProps {
  alerts: RxBenefitsCoverageAlert[] | null | undefined;
}

export const CoverageAlerts = ({ alerts }: CoverageAlertsProps) => {
  const grouped = Object.values(
    (alerts ?? [])
      .filter((a) => a.referenceText != null)
      .reduce<Record<string, { code: string | null; texts: string[] }>>(
        (acc, alert) => {
          const key = alert.referenceCode ?? "__null__";
          if (!acc[key]) acc[key] = { code: alert.referenceCode, texts: [] };
          acc[key].texts.push(alert.referenceText ?? "");
          return acc;
        },
        {},
      ),
  );

  if (grouped.length === 0) return null;

  return (
    <div className="flex flex-col gap-1.5">
      {grouped.map((group, index) => (
        <Callout
          key={group.code ?? `alert-${index}`}
          variant={alertVariant(group.code)}
          title={group.code ?? "Coverage Alert"}
        >
          {group.texts.map((text, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: ordered alert texts
            <p key={i} className="text-sm">
              • {text}
            </p>
          ))}
        </Callout>
      ))}
    </div>
  );
};
